// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Leon from '../../../Texas/data/counties/Leon.geo.json'
import Robertson from '../../../Texas/data/counties/Robertson.geo.json'
import Madison from '../../../Texas/data/counties/Madison.geo.json'
import Brazos from '../../../Texas/data/counties/Brazos.geo.json'
import Burleson from '../../../Texas/data/counties/Burleson.geo.json'
import Grimes from '../../../Texas/data/counties/Grimes.geo.json'
import Washington from '../../../Texas/data/counties/Washington.geo.json'

const counties = {
  Leon,
  Robertson,
  Madison,
  Brazos,
  Burleson,
  Grimes,
  Washington
}

export default counties
